import { useMemo } from "react";

const BloodGroup = ({ label, isRequired, placeholder = "Select", onChange = () => {}, value }) => {
  const bloodGroups = useMemo(() => ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"], []);

  return (
    <>
      {label && (
        <label className="mmmbaa_label">
          {label}
          {isRequired ? <span className="required_star">*</span> : ""}
        </label>
      )}
      <select className="input_select" onChange={(e) => onChange(e.target.value)}>
        <option value="">{placeholder}</option>
        {bloodGroups.map((group, index) => (
          <option key={index} selected={value === group}>
            {group}
          </option>
        ))}
      </select>
    </>
  );
};

export default BloodGroup;
